import { render, staticRenderFns } from "./ServiceGeneralForm.vue?vue&type=template&id=06b96ee4"
import script from "./ServiceGeneralForm.vue?vue&type=script&lang=ts"
export * from "./ServiceGeneralForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports